export default [
  {
    path: '/xinjiang',
    name: "xj",
    component: () => import('@/views/xinjiang/start.vue'),
    children: [
      {
        path: 'flow',
        name: "xjFlow",
        component: () => import('@/views/xinjiang/flow.vue'),
        meta: {
          title: '新疆移动用户专享'
        }
      },
      {
        path: 'confirmFlow',
        name: "xjConfirmFlow",
        component: () => import('@/views/xinjiang/confirmFlow.vue'),
        meta: {
          title: '新疆移动用户专享'
        }
      },
      {
        path: 'success',
        name: "xjFlowSuccess",
        component: () => import('@/views/xinjiang/success.vue'),
        meta: {
          title: '办理成功'
        }
      },
      {
        path: 'activity',
        name: "xjActivity",
        component: () => import('../views/xinjiang/activity.vue'),
        meta: {
          title: '新疆移动用户专享'
        }
      },
      {
        path: 'activitysuccess',
        name: "xjActivitySuccess",
        component: () => import('../views/xinjiang/activitySuccess.vue'),
        meta: {
          title: '新疆移动用户专享'
        }
      },
      {
        path: 'card',
        name: "xjCard",
        component: () => import('../views/xinjiang/card.vue'),
        meta: {
          title: '新疆移动用户专享'
        }
      },
      {
        path: 'cardSuccess',
        name: "xjCardSuccess",
        component: () => import('../views/xinjiang/cardSuccess.vue'),
        meta: {
          title: '新疆移动用户专享'
        }
      },
      {
        path: 'janflow',
        name: "xjJanFlow",
        component: () => import('../views/xinjiang/janflow.vue'),
        meta: {
          title: '新疆移动用户专享'
        }
      },
      {
        path: 'confirmjanflow',
        name: "xjConfirmJanFlow",
        component: () => import('../views/xinjiang/confirmjanflow.vue'),
        meta: {
          title: '新疆移动用户专享'
        }
      },
      {
        path: 'aprflow',
        name: "xjAprFlow",
        component: () => import('../views/xinjiang/aprflow.vue'),
        meta: {
          title: '新疆移动用户专享'
        }
      }
    ]
  }
]